import { AppPage } from 'common/Layout';
import { EducationPlan } from 'features/education-plan';
import { useEducationPlanPage } from './use-education-plan-page';

export const EducationPlanPage = () => {
  const { breadcrumbs, breadcrumbsLoading, educationPlan } = useEducationPlanPage();

  return (
    <AppPage
      breadcrumbs={{
        items: breadcrumbs,
        loading: breadcrumbsLoading,
      }}
      documentTitle={educationPlan?.name ?? 'Учебный план'}
    >
      <EducationPlan />
    </AppPage>
  );
};
